/*!
 * © 2026 Soulcute / Tailoring Consult — Todos los derechos reservados.
 * Bundle 3X2 — UI + modal selección variante + add to cart
 */
(function(){
  var el = document.getElementById('sc-b3x2');
  if (!el) return;
  var dataEl = document.getElementById('sc-b3x2-data');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch(e) { console.error('[b3x2] data parse error', e); return; }

  /* Estado: 3 slots TODOS empiezan vacíos. Cliente debe elegir activamente las 3 */
  var slots = [null, null, null];

  var ctaBtn = document.getElementById('sc-b3x2-cta');
  var missingEl = document.getElementById('sc-b3x2-missing');
  var modal = document.getElementById('sc-b3x2-modal');
  var modalBody = document.getElementById('sc-b3x2-modal-body');
  var modalTitle = document.getElementById('sc-b3x2-modal-title');
  var modalConfirm = document.getElementById('sc-b3x2-modal-confirm');
  var modalClose = document.getElementById('sc-b3x2-modal-close');
  var currentSlotIndex = null;
  var modalSelectedOpts = [];  /* selección temporal */

  /* === RENDER === */
  function fmt(cents){
    var n = Math.round(cents);
    return '$' + n.toLocaleString('es-CL');
  }

  function findVariantByOptions(opts){
    return D.variants.find(function(v){
      if (v.options.length !== opts.length) return false;
      return v.options.every(function(o, i){ return o === opts[i]; });
    });
  }

  function getVariantById(id){
    return D.variants.find(function(v){ return v.id === id; });
  }

  function updateSlot(idx, variantId){
    slots[idx] = variantId;
    var slotEl = el.querySelector('[data-slot="'+(idx+1)+'"]');
    if (!slotEl) return;
    var v = getVariantById(variantId);
    if (!v) return;

    slotEl.innerHTML =
      '<div class="sc-b3x2__slot-img">' +
        '<img src="' + v.image + '" alt="">' +
        '<span class="sc-b3x2__slot-num">' + (idx+1) + '/3</span>' +
      '</div>' +
      '<div class="sc-b3x2__slot-info">' +
        '<div class="sc-b3x2__slot-title">' + D.productTitle + '</div>' +
        '<div class="sc-b3x2__slot-variant">' + v.title + '</div>' +
      '</div>' +
      '<button type="button" class="sc-b3x2__edit" data-slot-action="'+(idx+1)+'">Cambiar</button>';
  }

  /* Resetea visualmente un slot a su estado vacío con botón "Seleccionar" */
  function resetSlotToEmpty(idx){
    slots[idx] = null;
    var slotEl = el.querySelector('[data-slot="'+(idx+1)+'"]');
    if (!slotEl) return;
    slotEl.innerHTML =
      '<div class="sc-b3x2__slot-img sc-b3x2__slot-img--empty">' +
        '<span class="sc-b3x2__slot-3x2">3X2</span>' +
        '<span class="sc-b3x2__slot-num">' + (idx+1) + '/3</span>' +
      '</div>' +
      '<button type="button" class="sc-b3x2__select" data-slot-action="'+(idx+1)+'">Seleccionar</button>';
  }

  function updateCtaState(){
    var filled = slots.filter(function(s){ return s !== null; }).length;
    var missing = 3 - filled;
    if (missing === 0) {
      ctaBtn.disabled = false;
      missingEl.parentElement.classList.add('is-ready');
      missingEl.parentElement.innerHTML = '&#10003; Listo para agregar al carrito';
    } else {
      ctaBtn.disabled = true;
      missingEl.parentElement.classList.remove('is-ready');
      missingEl.parentElement.innerHTML = 'Falta elegir <span id="sc-b3x2-missing">' + missing + '</span> producto(s) más';
      missingEl = document.getElementById('sc-b3x2-missing');
    }
  }

  /* === MODAL === */
  function openModal(slotIdx){
    currentSlotIndex = slotIdx;
    modalTitle.textContent = 'Elige producto ' + (slotIdx+1) + '/3';
    /* Inicializar opciones con la variante actual del slot (si existe) */
    var existing = slots[slotIdx] ? getVariantById(slots[slotIdx]) : null;
    modalSelectedOpts = existing ? existing.options.slice() : new Array(D.options.length).fill(null);
    renderModalOptions();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal(){
    modal.hidden = true;
    currentSlotIndex = null;
    document.body.style.overflow = '';
  }

  /* Map fallback de colores comunes Soulcute (cubre todos los nombres que detectamos en catálogo).
     Usado cuando el metaobject color-pattern del producto no tiene match exacto. */
  var COLOR_FALLBACK_MAP = {
    'negro': '#1a1a1a',
    'blanco': '#ffffff',
    'beige': '#EAD8AB',
    'café': '#9A5630',
    'cafe': '#9A5630',
    'marrón': '#9A5630',
    'marron': '#9A5630',
    'chocolate': '#5D4037',
    'café claro': '#C8A380',
    'cafe claro': '#C8A380',
    'gris': '#888888',
    'gris oscuro': '#555555',
    'rojo': '#C0392B',
    'cherry': '#C0392B',
    'rosa': '#F5B7B1',
    'rosado': '#F5B7B1',
    'verde': '#27AE60',
    'azul': '#2C3E50',
    'celeste': '#85C1E9',
    'morado': '#8E44AD',
    'camel': '#C19A6B',
    'piel': '#FFDDD2',
    'marfil': '#FFFFF0'
  };

  /* Lookup priorizado:
     1. Metaobject shopify.color-pattern del producto (más preciso, color custom)
     2. Map fallback global (cubre nombres comunes)
     3. null → render gris con inicial */
  function findColorData(label){
    var norm = String(label||'').toLowerCase().trim();
    /* 1. Metaobject */
    if (D.colorPattern && D.colorPattern.length) {
      var fromMeta = D.colorPattern.find(function(c){
        return String(c.label||'').toLowerCase().trim() === norm;
      });
      if (fromMeta && (fromMeta.color || fromMeta.image)) return fromMeta;
    }
    /* 2. Map fallback */
    if (COLOR_FALLBACK_MAP[norm]) {
      return { label: label, color: COLOR_FALLBACK_MAP[norm], image: null };
    }
    /* 3. null */
    return null;
  }

  function renderModalOptions(){
    var html = '';
    D.options.forEach(function(opt, optIdx){
      var isColorOpt = /color/i.test(opt.name);
      html += '<div class="sc-b3x2__opt-group">';
      html += '<label class="sc-b3x2__opt-label">' + opt.name + '</label>';
      html += '<div class="sc-b3x2__opt-values' + (isColorOpt?' sc-b3x2__opt-values--swatches':'') + '">';
      opt.values.forEach(function(val){
        var compatible = D.variants.some(function(v){
          if (!v.available) return false;
          if (v.options[optIdx] !== val) return false;
          for (var i=0; i<modalSelectedOpts.length; i++){
            if (i !== optIdx && modalSelectedOpts[i] !== null && v.options[i] !== modalSelectedOpts[i]) return false;
          }
          return true;
        });
        var isSelected = modalSelectedOpts[optIdx] === val;
        if (isColorOpt) {
          /* Buscar color real del metaobject color-pattern */
          var cd = findColorData(val);
          var style = '';
          var fallbackInitial = '';
          if (cd && cd.color) {
            style = 'background:' + cd.color + ';';
          } else if (cd && cd.image) {
            style = 'background-image:url(\'' + cd.image + '\');';
          } else {
            /* Fallback: gris con inicial */
            fallbackInitial = String(val).charAt(0).toUpperCase();
          }
          html += '<button type="button" class="sc-b3x2__swatch' + (isSelected?' is-selected':'') + '" data-opt-idx="'+optIdx+'" data-opt-val="'+val+'"' + (compatible?'':' disabled') + ' title="'+val+'">';
          html += '<span class="sc-b3x2__swatch-circle' + (fallbackInitial?' sc-b3x2__swatch-fallback':'') + '" style="'+style+'">' + fallbackInitial + '</span>';
          html += '<span class="sc-b3x2__swatch-label">' + val + '</span>';
          html += '</button>';
        } else {
          html += '<button type="button" class="sc-b3x2__opt-val' + (isSelected?' is-selected':'') + '" data-opt-idx="'+optIdx+'" data-opt-val="'+val+'"' + (compatible?'':' disabled') + '>' + val + '</button>';
        }
      });
      html += '</div>';
      html += '</div>';
    });
    modalBody.innerHTML = html;

    /* Hook handlers — incluye .sc-b3x2__opt-val Y .sc-b3x2__swatch */
    modalBody.querySelectorAll('.sc-b3x2__opt-val, .sc-b3x2__swatch').forEach(function(btn){
      btn.addEventListener('click', function(){
        if (btn.disabled) return;
        var idx = parseInt(btn.dataset.optIdx);
        var val = btn.dataset.optVal;
        modalSelectedOpts[idx] = val;
        renderModalOptions();
        updateModalConfirmState();
      });
    });

    updateModalConfirmState();
  }

  function updateModalConfirmState(){
    var allSelected = modalSelectedOpts.every(function(o){ return o !== null; });
    var v = allSelected ? findVariantByOptions(modalSelectedOpts) : null;
    modalConfirm.disabled = !v || !v.available;
  }

  function confirmModal(){
    var v = findVariantByOptions(modalSelectedOpts);
    if (!v || !v.available) return;
    updateSlot(currentSlotIndex, v.id);
    closeModal();
    updateCtaState();
  }

  /* === HOOKS === */
  el.addEventListener('click', function(e){
    var t = e.target.closest('[data-slot-action]');
    if (!t) return;
    var idx = parseInt(t.dataset.slotAction) - 1;
    openModal(idx);
  });

  modalClose.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e){ if (e.target === modal) closeModal(); });
  modalConfirm.addEventListener('click', confirmModal);

  ctaBtn.addEventListener('click', function(){
    if (ctaBtn.disabled) return;
    var items = slots.map(function(vid){
      return { id: vid, quantity: 1, properties: { '_sc_3x2': 'true' } };
    });
    ctaBtn.disabled = true;
    var origText = ctaBtn.innerHTML;
    ctaBtn.innerHTML = 'AGREGANDO...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function(r){ return r.json(); })
      .then(function(resp){
        if (resp.status && resp.status >= 400) {
          throw new Error(resp.description || 'Error agregando productos');
        }
        ctaBtn.innerHTML = '&#10003; AGREGADO AL CARRITO';
        setTimeout(function(){
          if (window.scOpenCartDrawer) { scOpenCartDrawer(); }
          else { window.location.href = '/cart'; }
        }, 600);
      })
      .catch(function(err){
        console.error('[b3x2] add error', err);
        ctaBtn.innerHTML = '&#9888; ERROR — REINTENTA';
        setTimeout(function(){ ctaBtn.innerHTML = origText; ctaBtn.disabled = false; }, 2500);
      });
  });

  /* Init: estado inicial — todos los slots vacíos, CTA disabled */
  updateCtaState();

  /* Timer "Stock limitado" — countdown 14:59 → 00:00 → reinicia */
  var te = document.getElementById('sc-b3x2-timer');
  if (te) {
    var m = 14, s = 59;
    setInterval(function(){
      s--;
      if (s < 0) { s = 59; m--; }
      if (m < 0) { m = 14; s = 59; }
      te.textContent = (m<10?'0':'') + m + ':' + (s<10?'0':'') + s;
    }, 1000);
  }

  /* (Removido: ya no se sincroniza slot 0 con variante actual del PDP — cliente debe elegir activo) */
})();
